export const SEARCH_INPUT_HEIGHT = {
  medium: 48,
  large: 56,
};
